import {IStateLuckydraw} from './reducer';
import {createActionFetch, createBasicActions} from '../../common/util/redux';
import {IForm, ILuckydrawTheme} from '../type';

export enum ActionType {
  SetValue = 'luckydraw.SetValue',
  SetPropertyValues = 'luckydraw.SetPropertyValues',
  FetchLuckydrawReward = 'luckydraw.FetchLuckydrawReward',
  FetchResult = 'luckydraw.FetchResult',
  FetchEnterInfo = 'luckydraw.FetchEnterInfo',
  FetchSubmitForms = 'luckydraw.FetchSubmitForms',
  FetchRaffle = 'luckydraw.FetchRaffle',
  InitializeAll = 'luckydraw.InitializeAll',
}

export const actions = {
  ...createBasicActions<IStateLuckydraw>({
    setValueActionType: ActionType.SetValue,
    setPropertyValuesActionType: ActionType.SetPropertyValues,
    initializeAllType: ActionType.InitializeAll,
  }),
  fetchLuckydrawReward: (payload: {
    drawId: number;
    rewardId: number;
    luckydrawId: string;
  }) => createActionFetch(ActionType.FetchLuckydrawReward, {payload}),
  fetchResult: (payload: {
    drawId: number;
    rewardId: number;
    luckydrawId: string;
    theme: ILuckydrawTheme;
  }) => createActionFetch(ActionType.FetchResult, {payload}),
  fetchEnterInfo: (payload: {
    presentId?: number;
    rewardId: number;
    luckydrawId: string;
  }) => createActionFetch(ActionType.FetchEnterInfo, {payload}),
  fetchSubmitForms: (payload: {
    forms: IForm[];
    presentId?: number;
    rewardId: number;
    luckydrawId: string;
  }) =>
    createActionFetch(ActionType.FetchSubmitForms, {
      payload,
      fetchKey: payload.luckydrawId,
    }),
  fetchRaffle: (payload: {uid: string; rewardId: number}) =>
    createActionFetch(ActionType.FetchRaffle, {
      payload,
    }),
};
